<template>
  <div class="product-filter-variants" :class="{ full: isOnProductDetailPage }">
    <Popup ref="popup">
      <template slot="control">
        <label>
          <span v-if="false" class="label">
            Options
            <span class="label-count" v-if="totalFiltersActive">({{totalFiltersActive}})</span>
            <span class="label-icon">
              <img  src="../../assets/images/icon-help.svg" />
            </span>
          </span>
          <!-- <span class="label--mobile"><SvgIconFilter />Filter</span> -->
          <span class="button-wrap">
          <button
            class="product-filter-variants-button"
            @focus="handleFocus"
            :v-model="search"
            ref="filterOptionsInput"
          > <span class="product-filter-variants-cta-alt">Filter Variants</span><span class="product-filter-variants-cta">All Options</span></button>
          </span>
        </label>
      </template>

       <template slot="content">
        <div class="product-filter-variants__top">
          <div class="product-filter-variants__search">
            <input
              class="product-filter-variants__search-input"
              :placeholder="`Search Variants`"
              :type="`text`"
              v-model="search"
              ref="search"
            />
            <span class="product-filter-variants__search-icon"></span>
          </div>
        </div>
        <div class="product-filter-variants__bottom">
          <ul class="product-filter-variants__options product-filter-variants__static-options">
            <router-link
              :class="[
                `product-filter-variants__option`,
                !filteredCollection && `product-filter-variants__option--is-active`
              ]"
              :active-class="`product-filter-variants__option--is-active`"
              :exact="true"
              :tag="`li`"
              :to="{ name: 'Products' }"
              @click.native="handleLinkClick"
            >
            </router-link>
          </ul>
          <ul class="product-filter-variants__options product-filter-variants__dynamic-options" v-if="filtersDropdown">
            <li v-for="filter in filtersDropdown" :class="`product-filter-variants__option`" :key="filter.id">
              <a
                :id="filter.id"
                :class="`product-filter-variants__option-link`"
                :href="filter._links.self.href"
                @click.prevent="addActiveFilter($event, filter)"
              >
                {{ filter.title }}
              </a>
            </li>
          </ul>
          <div class="product-filter-variants__no-match" v-else>
            <p class="product-filter-variants__no-match-text">No matches found.</p>
          </div>
        </div>
      </template>

    </Popup>
  </div>
</template>

<script>
  import Popup from '@/components/Popup/Popup'

  import SvgIconFilter from '@/svgs/SvgIconFilter'

  import { productFilter } from '@/mixins/productFilter.js'

  export default {
    name: 'ProductFilterVariants',
    components: {
      Popup,
      SvgIconFilter
    },
    mixins: [ productFilter ],
    props: {
      isOnProductDetailPage: Boolean,
      possibleFilters: Array,
      totalFiltersActive: Number
    },
    data () {
      return {
        filters: [],
        placeholderText: 'Start typing Green',
        filtersDropdown: null,
        filteredCollection: this.items,
        search: '',
        isPopupOpen: false,
        tooltipContent: 'Helpful tips to go here.'
      }
    },
    computed: {
      // NOTE
      // used as param in api call
      // see: @mixins/filters
      filterType: function () {
        return 'option'
      }
    },
    methods: {
      closeDropdown () {
        this.search = ''
        this.forceClosePopup()
      },
      forceClosePopup () {
        const $popup = this.$refs.popup
        // this.filtersDropdown = null
        this.search = ''
        $popup.close()
      },
      handleFilterHelp () {},
      handleBlur () {
        this.placeholderText = 'Start typing Green'
      },
      handleFocus () {
        this.placeholderText = ''
        this.loadSearch()
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../scss/abstracts/__dir';
  @import '../../scss/global/__dir';

  $ns: '.product-filter-variants';

  .label-count {
    margin-left: 3px;
  }
  .label {
    color: black;
    display: block;
    font-family: "Roboto Medium", Helvetica, Arial, sans-serif;
    font-size: 14px;
    margin-bottom: 10px;
    display: flex;
    align-items: center;

    &-icon {
      display: none;
      @include breakpoint($desktop) {
        display: block;
        margin-left: 6px;
      }
    }
  }

  .button-wrap {
    background-color: white;
    border-radius: 3px;
    border: 1px solid #e4e4e4;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.04);
    display: block;
    width: 100%;
  }

  .product-filter-variants-button {
    background-color: rgba(255, 255, 255, 0);
    border: none;
    color: #999999;
    display: inline-block;
    height: 50px !important;
    line-height: 50px !important;
    padding: 0 18px !important;
    transition: width 0.3s;
    font-size: 15px;
    @include breakpoint($desktop) {
      font-size: 15px;
    }
    width: 100%;
    text-align: left;
    background-image: url('../../assets/images/icon-chevron-down.svg');
    background-repeat: no-repeat;
    background-position: right 15px center;
  }

  #{$ns} {
    &-cta-alt {
      display: none;
      .product-detail-active & {
        display: block;
      }
    }

    &-cta {
      display: block;
      .product-detail-active & {
        display: none;
      }
    }

    &.full {
      width: 100%;
      .page-products & {
        @include breakpoint($desktop) {
          max-width: 370px;
        }
        box-shadow: 0 2px 12px 0 rgba(0,0,0,.09);
        border: 1px solid #e4e4e4;
        border-radius: 3px;
      }
    }

    .button-wrap {
      .page-products & {
        box-shadow: none;
        border: none;
      }
    }

    &__no-match-text {
      font-size: 14px;
    }

    &__search-input {
    color: $black;
    background-color: transparent;
    border: none;
    display: inline-block;
    flex-grow: 1;
    height: 38px;
    letter-spacing: 0;
    line-height: 38px;
    margin: 0;
    padding: 0;
    width: auto;
  }


  &__dropdown {
    background-color: rgba(255, 255, 255, 0);
    border: none;
    color: #000;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-grow: 1;
    font-family: "Roboto", Helvetica, Arial, sans-serif;
    font-size: 15px;
    height: 51px !important;
    line-height: 51px !important;
    padding: 0 18px !important;
    position: relative;
    text-align: right;
    width: 100%;
    min-width: 200px;
    @include breakpoint($desktop) {
      width: 20vw;
    }
    @include breakpoint(1600px) {
      width: 30vw;
    }

  }

  &__bottom {}

    &__dynamic-options {
      overflow: auto;

      #{$ns}__option {
        &:last-child {
          border-radius: 0 0 3px 3px;
        }
      }
    }

    &__no-match {
      padding: 16px;
    }

    &__option {
      color: color('dusty-gray');
      cursor: pointer;
      font-size: 0;
      position: relative;

      &:after {
        background-color: color('black');
        content: '';
        display: none;
        height: 100%;
        left: 0;
        position: absolute;
        top: 0;
        width: 4px;
      }

      &:hover,
      &--is-active {
        // color: color('black');
        //font-family: $font-primary-medium;
        background-color: #f9f9f9;

        &:after {
          display: block;
        }
      }
    }

    &__option-link {
      color: inherit;
      display: inline-block;
      font-size: 15px;
      height: 40px;
      line-height: 40px;
      max-width: 298px;
      overflow: hidden;
      padding: 0 20px;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 100%;
      color: #444;
    }


    &__search {
      background-color: #fdfdfe;
      //border-radius: 20px;
      border-radius: 4px;
      border: 1px solid #e5e5e5;
      display: flex;
      height: 40px;
      padding: 0 16px;
      justify-content: space-between;
      font-size: 13px;
      width: 100%;
      @include breakpoint($desktop) {
        min-width: 266px;
      }
    }

    &__search-icon {
      color: #999;
      height: 38px;
      margin-left: 12px;
      position: relative;
      width: 16px;

      @include icon($icon-search);

      &:before {
        transform: scale(-1, 1);
        font-weight: bold;
        font-size: 12px;
        line-height: 17px;
        margin: auto;
        height: 17px;
        bottom: 0;
      }
    }



    &__form-group {
      //margin-top: 16px;
      background-color: white;
      border-radius: 3px;
      border: 1px solid #e4e4e4;
      //margin-bottom: 15px;
      box-shadow: 0 3px 12px 0 rgba(0, 0, 0, 0.09);
      @include breakpoint($desktop) {
        margin-right: 12px;
        margin-bottom: 0;
      }

    }

    &__top {
      padding: 12px 14px;
    }

    .interactive-svg-icon {
      height: 38px;
      width: 47px;

      @include button-appearance-small;

      &--is-active {
        @include button-appearance-when-active;
      }
    }

    .popup-content {
      @include popup-box-appearance;
      background-color: #ffffff;
      border-radius: 3px;
      box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.22) !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/js/components/ProductFilterVariants.vue